<!-- [*AppBar] -->

<div *ngIf="homologationBannerEnabled" role="alert" class="homologation-banner">
  <span class="homologation-icon">⚠️</span>
  <span>Ambiente de Homologação — Apenas para Testes | Dados não oficiais</span>
</div>

<ng-container *ngIf="!mostrarMenu">
  <po-page-default class="po-page-login-container">
    <router-outlet></router-outlet>
  </po-page-default>
</ng-container>

<ng-container *ngIf="mostrarMenu">
  <ng-container *ngIf="tipoUser">
    <po-navbar [p-icon-actions]="navActions" p-shadow="true" p-logo="assets/logo.jpg"
      *ngIf="!importacaoService.estaImportando()">
      <po-menu [p-menus]="menus"></po-menu>
    </po-navbar>

    <div class="po-wrapper">
      <po-menu *ngIf="!importacaoService.estaImportando()" [p-menus]="menus" [p-collapsed]="true"></po-menu>
      <po-page-default>
        <router-outlet></router-outlet>
      </po-page-default>
    </div>
  </ng-container>

  <ng-container *ngIf="!tipoUser">
    <po-navbar p-shadow="true" p-logo="assets/logo.png" *ngIf="!importacaoService.estaImportando()">
      <po-menu [p-menus]="menusA" [p-collapsed]="true"></po-menu>
    </po-navbar>

    <div class="po-wrapper">
      <po-menu *ngIf="!importacaoService.estaImportando()" [p-menus]="menusA" [p-collapsed]="true">
        <ng-template p-menu-header-template>
          <div class="po-m-5">
            <font style="color: rgb(255, 255, 255); margin: auto;"></font>
          </div>
        </ng-template>
      </po-menu>
      <po-page-default>
        <router-outlet></router-outlet>
      </po-page-default>
    </div>
  </ng-container>
</ng-container>